import { MockFactory } from '@tino-frontend/mocks'
import { QuizResponse } from '@types'

export const quizAPIMock = new MockFactory<QuizResponse>({
  id: 'asdasd-asdsad-asdasdas',
  questions: [
    {
      order: 1,
      sentence:
        'Qual das opções abaixo indica o segmento de uma das empresa para a qual você trabalha ou já trabalhou como CLT?',
      options: [
        'FABRICACAO DE BISCOITOS E BOLACHAS',
        'EDUCACAO SUPERIOR - GRADUACAO E POS-GRADUACAO',
        'FABRICACAO DE PILHAS, BATERIAS E ACUMULADORES ELETRICOS, EXCETO PARA VEICULOS AUTOMOTORES',
        'FABRICACAO DE MEIAS',
      ],
    },
    {
      order: 2,
      sentence: 'Qual destes CEPs lhe parece mais familiar?',
      options: ['21045669', '21046060', '21042078', '21041929'],
    },
    {
      order: 3,
      sentence: 'Qual destes telefones lhe parece mais familiar?',
      options: ['29409971', '970777994', '27119074', '28245510'],
    },
    {
      order: 4,
      sentence: 'Em quantas empresas você já trabalhou de carteira assinada?',
      options: ['1 A 2', '19 A 20', '15 A 16', '9 A 10'],
    },
  ],
})
